import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Globals } from '../../globals';

import { AddressId, AddressService } from '../../services/address.service';
import { PayrollId } from '../../services/catalogs-settings.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { Utils } from '../../util';

@Component({
	selector: 'app-read-address',
	templateUrl: './read-address.component.html',
	styleUrls: ['./read-address.component.css', '../../app.component.css']
})

export class ReadAddressComponent implements OnInit {

	parent: any;
  customerOrSupplier: string;
	addresses: any[] = [];
	adressSub: Subscription;

	data: Array<any>;
	rows: Array<any> = [];
	columns: Array<any> = [
		{ title: 'Dirección', name: 'name', sort: 'asc' },
		{ title: 'Folio', name: 'folio' },
		{ title: 'C.P.', className: 'center', name: 'zipCode' },
		{ title: 'Municipio', className: 'center', name: 'municipality' },
		{ title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
	];

	page = 1;
	itemsPerPage = 10;
	maxSize = 5;
	numPages = 1;
	length = 0;
	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: '' },
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
	};

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private addressService: AddressService,
		private fsService: FirestoreService,
	) {

    this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
		this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];
		this.loadAddresses();
	}

	ngOnInit() {
	}
	ngOnDestroy() {
		this.adressSub.unsubscribe();
	}
	//tmp function to add folios
	/* async setFolios(){
		let addresss = await this.fsService.colWithIds<AddressId>(`${Globals.ADDRESSES_COLLECTION}`, ref => ref.where('active', '==', true));
		if(!addresss) return console.log('Col get error.');
		console.log(`Address length: ${addresss.length}`);
		console.log(addresss);
		try{
			for(let i = 0; i < addresss.length; i++){
				let result = await this.fsService.update(`${Globals.ADDRESSES_COLLECTION}/${addresss[i].id}`, {folio: `DE${Utils.String.fillLeft(`${i + 1}`, '0', 6)}`});
				console.log('Set folio success.');
			}
			let settings = await this.fsService.docWithId<PayrollId>(`${Globals.CATALOGS_SETTINGS}/1`);
			if(!settings) return console.log('Settings get error');
			let folios = {
				...settings.folios,
				address: addresss.length,
			};

		}catch(error){
			console.log(error);
		}
	} */

	loadAddresses() {
		this.adressSub = this.addressService.getAddresses(this.parent, this.customerOrSupplier).subscribe(tempAddresses => {
			this.addresses = [];

			for (const idx in tempAddresses) {
					this.addresses.push(tempAddresses[idx]);
			}

			this.data = this.addresses;
			this.length = this.data.length;
			this.onChangeTable(this.config);
		});
	}
	newAddress(){
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/add_address']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/add_address']);
		}
	}

	onCellClick(data: any): any {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent +'/vw_address/', data.row.id]);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent +'/vw_address/', data.row.id]);
		}
	}

	onEdit(data: any) {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/edt_address/', data.row.id]);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/edt_address/', data.row.id]);
		}
	}

	onDelete(data: any) {
		this.addressService.deleteAddress(data.row.id);
	}

	// *************** Table functionality *************** //
	changePage(page: any, data: Array<any> = this.data): Array<any> {
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

		return data.slice(start, end);
	}

	changeSort(data: any, config: any): any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns;
		let columnName: string;
		let sort: string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous: any, current: any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}

			return 0;
		});
	}

	changeFilter(data: any, config: any): any {
		let filteredData: Array<any> = data;

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray: Array<any> = [];

		filteredData.forEach((item: any) => {
			let flag = false;

			this.columns.forEach((column: any) => {
				if (item[column.name] &&
					item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});

			if (flag) {
				tempArray.push(item);
			}
		});

		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
		if (config.filtering) {
				Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
				Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);

		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

}